<template>
  <div class="training-form">
    <div class="row text-center">
      <br>
      <div class="col-xs-12">
        <h1 class="text-uppercase">step 9: Training</h1>
        <br>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-4">
        <input
          v-model="training.moduleName"
          type="text"
          class="form-control admin-form-control input-lg"
          placeholder="Module Name">
      </div>
      <div class="col-sm-4">
        <input
          v-model="training.points"
          type="number"
          class="form-control admin-form-control input-lg"
          placeholder="Points">
      </div>
      <div class="col-sm-4">
        <input
          v-model="training.videoUrl"
          type="text"
          class="form-control admin-form-control input-lg"
          placeholder="Video Url">
      </div>
      <div class="col-sm-12">
        <textarea
          v-model="training.description"
          rows="4"
          class="form-control admin-form-control input-lg"
          placeholder="Module Description">
        </textarea>
      </div>
      <div class="col-sm-12">
        <input v-model="currentQuestion.text" type="text" class="form-control admin-form-control input-lg" :placeholder="`Question ${questionLevel}`">
      </div>

      <div class="answer">
        <div class="col-sm-8">
          <input v-model="currentQuestion.answerOne.text" type="text" class="form-control admin-form-control input-lg" placeholder="Answer 1">
        </div>
        <div class="col-sm-4 radio-space">
          Correct
          <label class="radio-inline">
            <input v-model="currentQuestion.answerOne.correct" type="radio" id="inlineCheckbox1" :value="true">Yes</label>
          <label class="radio-inline">
            <input v-model="currentQuestion.answerOne.correct" type="radio" id="inlineCheckbox2" :value="false">No</label>
        </div>
      </div><!-- answer -->

      <div class="answer">
        <div class="col-sm-8">
          <input v-model="currentQuestion.answerTwo.text" type="text" class="form-control admin-form-control input-lg" placeholder="Answer 2">
        </div>
        <div class="col-sm-4 radio-space">
          Correct
          <label class="radio-inline">
            <input v-model="currentQuestion.answerTwo.correct" type="radio" id="inlineCheckbox1" :value="true">Yes</label>
          <label class="radio-inline">
            <input v-model="currentQuestion.answerTwo.correct" type="radio" id="inlineCheckbox2" :value="false">No</label>
        </div>
      </div><!-- answer -->

      <div class="answer">
        <div class="col-sm-8">
          <input v-model="currentQuestion.answerThree.text" type="text" class="form-control admin-form-control input-lg" placeholder="Answer 3">
        </div>
        <div class="col-sm-4 radio-space">
          Correct
          <label class="radio-inline">
            <input v-model="currentQuestion.answerThree.correct" type="radio" id="inlineCheckbox1" :value="true">Yes</label>
          <label class="radio-inline">
            <input v-model="currentQuestion.answerThree.correct" type="radio" id="inlineCheckbox2" :value="false">No</label>
        </div>
      </div><!-- answer -->

      <div class="answer">
        <div class="col-sm-8">
          <input v-model="currentQuestion.answerFour.text" type="text" class="form-control admin-form-control input-lg" placeholder="Answer 4">
        </div>
        <div class="col-sm-4 radio-space">
          Correct
          <label class="radio-inline">
            <input v-model="currentQuestion.answerFour.correct" type="radio" id="inlineCheckbox1" :value="true">Yes</label>
          <label class="radio-inline">
            <input v-model="currentQuestion.answerFour.correct" type="radio" id="inlineCheckbox2" :value="false">No</label>
        </div>
      </div><!-- answer -->

      <div class="col-sm-12">
        <textarea v-model="currentQuestion.explanation" class="form-control admin-form-control input-lg" rows="7" placeholder="Correct Answer Explanation"></textarea>
      </div>

      <div class="clearfix"></div>
      <div class="col-sm-6" v-if="!validAnswer || !validTraining">
        <div class="alert alert-danger">
          <ul>
            <li v-if="!validAnswer">There must only be one correct answer to add question.</li>
            <li v-if="!validTraining">There must be at least one saved question to save the module.</li>
          </ul>
        </div>
      </div>
      <div class="clearfix"></div>
      <div class="col-sm-4">
        <a
          href="#"
          type="button"
          :class="questionBtnClasses"
          @click.prevent="addQuestion">
          Save/Add Question&nbsp; <span class="glyphicon glyphicon-plus glyphicon "></span>
        </a>
      </div>
      <div class="col-sm-4">
        <a
          href="#"
          type="button"
          :class="trainingBtnClasses"
          @click.prevent="addTraining">
          Save/Add Training&nbsp; <span class="glyphicon glyphicon-plus glyphicon "></span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TrainingForm',
  data () {
    return {
      trainings: [],
      training: {
        moduleName: null,
        videoUrl: null,
        points: null,
        description: null,
        questions: []
      },
      currentQuestion: {
        text: null,
        answerOne: {
          text: null,
          correct: false
        },
        answerTwo: {
          text: null,
          correct: false
        },
        answerThree: {
          text: null,
          correct: false
        },
        answerFour: {
          text: null,
          correct: false
        },
        explanation: null
      }
    }
  },
  computed: {
    questionBtnClasses () {
      const common = 'form-but btn admin-btn-primary btn-lg btn-block text-uppercase'
      return this.validAnswer ? common : common + ' disabled'
    },
    trainingBtnClasses () {
      const common = 'form-but btn admin-btn-primary btn-lg btn-block text-uppercase'
      return this.validTraining ? common : common + ' disabled'
    },
    questionLevel () {
      return this.training.questions.length + 1
    },
    validAnswer () {
      const answers = ['answerOne', 'answerTwo', 'answerThree', 'answerFour']
      return answers.filter(answer => this.currentQuestion[answer].correct).length === 1
    },
    validTraining () {
      return this.training.questions.length > 0
    }
  },
  methods: {
    addTraining () {
      if (!this.validTraining) return
      this.trainings.push(this.training)
      this.$emit('input', this.trainings)
      this.resetTraining()
      this.resetCurrentQuestion()
    },
    addQuestion () {
      if (!this.validAnswer) return
      this.training.questions.push(this.currentQuestion)
      this.resetCurrentQuestion()
    },
    resetTraining () {
      this.training = {
        moduleName: null,
        videoUrl: null,
        questions: []
      }
    },
    resetCurrentQuestion () {
      this.currentQuestion = {
        text: null,
        answerOne: {
          text: null,
          correct: false
        },
        answerTwo: {
          text: null,
          correct: false
        },
        answerThree: {
          text: null,
          correct: false
        },
        answerFour: {
          text: null,
          correct: false
        },
        explanation: null
      }
    }
  }
}
</script>
